<template>
	<CampaignLayout :subtitle="trans('tools.campaigns.send.everyone')" :campaign="campaign">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="send">
				<i class="fa-solid fa-paper-plane mr-2"/>
				{{ trans('general.send') }}
			</PrimaryButton>
		</template>
		<Alert :color="Color.Yellow">{{ trans('tools.campaigns.send.warning') }}</Alert>
	</CampaignLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import Alert from '@/Components/UI/Alerts/Alert.vue'
import CampaignLayout from '@/Layouts/CampaignLayout.vue'
import {type Campaign} from '@/Types/Tools/Campaigns/Campaign'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	campaign:Campaign,
}>()

const working:Ref<boolean> = ref(false)
const campaign:Ref<Campaign> = ref(props.campaign)

function send(){
	if(!working.value && confirm(trans('tools.campaigns.mails.confirm_all'))){
		working.value = true
		showInfo(trans('campaigns.campaigns.mails.sending'))
		axios.post(route('tools.campaigns.send.everyone.store', campaign.value.id)).then(() => {
			showSuccess(trans('tools.campaigns.mails.sent'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>
